<template>
  <v-container fluid>
<!--    <v-layout align-center justify-center fill-height>-->
<!--      <v-flex xs12 sm8 md5>-->
<!--        <img src="../../static/img/doe-logo.png" alt="">-->
<!--        <div style="font-size: 2.5rem; font-weight: bold; margin: 10px">SYSTEM UPDATE IN PROGRESS</div>-->
<!--        <div style="font-size: 1.5rem; margin: 10px">We apologize for any inconvenience this may cause. Thank you for your patience.</div>-->
<!--        <div style="margin: 10px">Last Updated: 11/03/2020</div>-->
<!--      </v-flex>-->
<!--    </v-layout>-->
    <v-layout align-center justify-center fill-height>
      <v-flex xs12 sm8 md5>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Login</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <img src="../../static/img/doe-logo.png" alt="">
            <v-form>
              <v-text-field prepend-icon="person"
                            name="login"
                            v-model.trim="username"
                            label="Username"
                            :error-messages="usernameErrors"
                            @blur="$v.username.$touch"
                            @keyup.enter="onLoginClick"
                            autocomplete="off"
                            type="text">
              </v-text-field>
              <v-text-field prepend-icon="lock"
                            name="password"
                            v-model.trim="password"
                            label="Password"
                            :error-messages="passwordErrors"
                            @blur="$v.password.$touch"
                            @keyup.enter="onLoginClick"
                            autocomplete="off"
                            type="password">
              </v-text-field>
              <v-alert :value="errorMsg"
                       type="error">
                {{errorMsg}}
              </v-alert>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-on:click.prevent="onLoginClick"
                       :disabled="loading || $v.$invalid"
                       color="primary">
                  Login
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <div v-if="loading">
      <loading-component></loading-component>
    </div>
  </v-container>
</template>

<script>
/* eslint-disable indent */
  import { required } from 'vuelidate/lib/validators';
  import api from '@/utils/api';
  import * as Constants from '@/constants';
  import JWTHelper from '@/jwt-token';
  import LoadingComponent from './loading-component';

  export default {
    name: 'Login',
    components: {
      LoadingComponent
    },
    data() {
      return {
        username: '',
        password: '',
        loading: false,
        errorMsg: ''
      };
    },
    methods: {
      onLoginClick() {
        this.loading = true;
        // set username and password
        const body = {
          username: this.username,
          password: this.password
        };
        let userId;

        api.post(Constants.AUTHENTICATION_URL(), body)
          .then((res) => {
            // update token in local storage, need to change it to cookies
            const token = res.data.data.token;
            localStorage.setItem('user-token', token);
            const user = res.data.data.user;
            localStorage.setItem('dynatrace-usertag', user.fullName);
            userId = user.userId;
            /**
             * if the user is NOT a proxy and NOT an admin and IS a provider
             * they can only file SL for themselves
             * set providerId in localStorage to use later
             */
            if (!user.proxy && !user.isAdmin && user.isProvider) {
              localStorage.setItem('provider-id', userId);
            }
            return api.get(Constants.GET_USER_PREFERENCES_URL(userId));
          })
          .then((pref) => {
            const schedulerRoute = '/agency-scheduler';
            const slRoute = '/dashboard';
            // set the users preference for tooltip
            const nursingHelpPreference = pref.data.data.filter((p) => {
              return p.preferenceKey === 'nursing_help';
            })[0];
            const showTooltip = nursingHelpPreference.value === 'enabled';
            this.$store.commit('tooltip', showTooltip);
            // if the user has full rights to the app, check their preferences
            if (JWTHelper.hasFullRights()) {
              const preferencesArray = pref.data.data;
              // save the user preferences to local storage
              localStorage.setItem('user-preferences', JSON.stringify(preferencesArray));
              // find the view preference in the preference array
              // view preferences will be an array, so take the first record
              const viewPreferences = preferencesArray.filter((preference) => {
                return preference.preferenceKey === 'nursing_menu_default';
              })[0];
              if (viewPreferences) {
                // take the user to their set preference
                if (viewPreferences.value === 'schedule') {
                  this.$router.push(schedulerRoute);
                } else if (viewPreferences.value === 'logs') {
                  this.$router.push(slRoute);
                }
              }
            } else if (JWTHelper.hasSchedulerRights()) {
              this.$router.push(schedulerRoute);
            } else if (JWTHelper.hasServiceLogRights()) {
              this.$router.push(slRoute);
            } else {
              throw new Error('This user does not have rights to access this app.');
            }
          })
          .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) {
              this.errorMsg = error.response.data.message;
            } else {
              this.errorMsg = error.message;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    computed: {
      usernameErrors() {
        const errors = [];
        if (!this.$v.username.$dirty) return errors;
        if (!this.$v.username.required) errors.push('Username is required.');
        return errors;
      },
      passwordErrors() {
        const errors = [];
        if (!this.$v.password.$dirty) return errors;
        if (!this.$v.password.required) errors.push('Password is required.');
        return errors;
      },
      isMobile() {
        return this.$mq === 'mobile';
      }
    },
    validations: {
      username: {
        required
      },
      password: {
        required
      }
    }
  };
</script>
<style scoped>
  img {
    height: 15vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue